export enum ToastTypeEnum { 
    Error = "Error",
    Success = "Success",
    Notification = "Notification"
}